import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './CurrentPosition.scss';
import '../CitySelection.scss';
function CurrentPosition(props) {
    const { locationCity } = props;
    return <View>
      <View className="current-position-top-text-container">
        <Text className="city-selection-little-gray-text" style={{
        fontSize: '28rpx'
    }}>{`当前城市: ${locationCity}`}</Text>
      </View>
      <View className="city-selection-short-divider"/>
    </View>;
}
export default CurrentPosition;
